import { Element, Root as HastRoot } from 'hast';
import { visit } from 'unist-util-visit';

import { createSlugDeduplicator, generateHeadingSlug } from '../../utils/markdownLinks';

const headingTags = new Set(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']);

function extractText(node: Element): string | null {
  for (const child of node.children) {
    if (child.type === 'text') {
      return child.value;
    }
  }
  return null;
}

export default function rehypeHeadingIds(deduplicateSlug = createSlugDeduplicator()) {
  return function (tree: HastRoot) {
    visit(tree, 'element', function (node) {
      if (!headingTags.has(node.tagName)) return;
      const text = extractText(node);
      if (text) {
        node.properties['id'] = deduplicateSlug(generateHeadingSlug(text));
      }
    });
  };
}
